import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LocalStorageController, LOCAL_STORAGE_DATA } from "../../utils/LocalStorageController";
import { PAGE_NAME } from "../../../types";

const InviteHandler = () => {
    const { code } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (code) {
            console.log("Capturing invitation code:", code);
            LocalStorageController.connect().storeData(LOCAL_STORAGE_DATA.INVITATION_CODE, code);
        }
        navigate(PAGE_NAME.LOGIN, { replace: true });
    }, [code, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-slate-900">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
    );
};

export default InviteHandler;
